// extracted by mini-css-extract-plugin
export default {"dropdownContent":"LeadTickets_dropdownContent__8goBL","ticketButton":"LeadTickets_ticketButton__Umu7G","unassigned":"LeadTickets_unassigned__8Esgo"};